import React from "react";

interface FormFieldProps {
  name: string;
  type: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: boolean;
  helperText: string;
  required: boolean;
  optional: boolean;
  FieldComponent: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({
  name,
  type,
  placeholder,
  value,
  onChange,
  error,
  helperText,
  required = false,
  optional = false,
  FieldComponent,
}) => {
  return (
    <div className="flex flex-col">
      {React.cloneElement(
        FieldComponent as React.ReactElement,
        {
          name,
          type,
          placeholder,
          value,
          onChange,
          error,
          helperText,
          required,
          optional,
        } as any
      )}
    </div>
  );
};

export default FormField;

interface FormFieldLabelProps {
  label?: string;
  className?: string;
  required?: boolean;
  optional?: boolean;
}

export const FormFieldLabel: React.FC<FormFieldLabelProps> = ({
  label,
  className,
  required,
  optional,
}) => {
  if (!label) return null;
  return (
    <label
      className={`block text-sm font-medium text-[var(--text-secondary)] mb-2 ${className}`}
    >
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
      {optional && <span className="text-gray-500 ml-1">(optional)</span>}
    </label>
  );
};

interface FormHelperTextProps {
  helperText?: string;
  error?: boolean;
}

export const FormHelperText: React.FC<FormHelperTextProps> = ({
  helperText = "",
  error = false,
}) => {
  if (!helperText) return null;
  return (
    <div className={`${error ? "text-red-500" : "text-gray-800"} text-xs mt-1`}>
      {helperText}
    </div>
  );
};
